import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { NavLink } from "react-router-dom";

const values = [
  { title: "Selezione", desc: "Solo articoli dei migliori brand internazionali, accuratamente selezionati per qualità e stile. Ogni giorno nuove occasioni da non perdere." },
  { title: "Convenienza", desc: "Sconti reali fino al −70% senza compromettere la qualità. Crediamo in uno shopping consapevole, fatto di qualità e convenienza reale." },
  { title: "Affidabilità", desc: "Spedizioni veloci in tutta Europa, reso facile entro 14 giorni e pagamenti protetti al 100%. La tua soddisfazione è la nostra priorità." },
  { title: "Accessibilità", desc: "Rendiamo la moda premium accessibile a tutti. Un'unica destinazione per abbigliamento, scarpe e accessori a prezzi outlet." },
];

const timeline = [
  { year: "2018", label: "Nasce Brupa Fashion Mall: l'idea di rendere la moda premium accessibile a tutti" },
  { year: "2020", label: "Espansione internazionale: prime spedizioni in Germania, Austria e Benelux" },
  { year: "2022", label: "Superata la soglia di 10.000 ordini. Community Bruper in continua crescita" },
  { year: "2024", label: "Partnership con oltre 50 brand internazionali premium tra cui Diesel, BOSS, Dsquared2" },
  { year: "2026", label: "Lancio della nuova piattaforma multilingua con supporto in italiano, inglese e tedesco" },
];

export default function About() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1">
        {/* Hero */}
        <section className="relative overflow-hidden" style={{ minHeight: "60vh" }}>
          <img
            src="https://brupa.it/cdn/shop/files/packaging_brupa.jpg"
            alt="Brupa Fashion Mall"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-stone-900/65" />
          <div className="relative flex items-center justify-center text-center" style={{ minHeight: "60vh" }}>
            <div className="px-6">
              <p className="text-[10px] tracking-[0.4em] uppercase text-emerald-400 font-semibold mb-5">Fashion Mall Online</p>
              <h1 className="font-semibold text-white text-3xl sm:text-4xl md:text-6xl md:font-bold tracking-tight leading-tight">
                Chi siamo
              </h1>
            </div>
          </div>
        </section>

        {/* Intro */}
        <section className="py-24 bg-white">
          <div className="max-w-3xl mx-auto px-6 text-center">
            <p className="text-[10px] tracking-[0.3em] uppercase text-emerald-600 font-semibold mb-6">La nostra missione</p>
            <p className="font-medium text-lg sm:text-xl md:text-3xl md:font-semibold text-stone-800 leading-snug tracking-tight">
              "Brupa nasce dalla convinzione che la moda premium possa essere accessibile a tutti, senza compromettere qualità e stile."
            </p>
            <p className="mt-4 text-stone-400 text-sm italic">— Il team Brupa Fashion Mall</p>
          </div>
        </section>

        {/* Cosa offriamo */}
        <section className="pb-20 bg-white">
          <div className="max-w-3xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-12">
              <div>
                <h2 className="font-medium text-lg sm:text-xl md:text-2xl md:font-semibold text-stone-900 tracking-tight mb-4">Cosa offriamo</h2>
                <p className="text-stone-500 text-sm leading-relaxed">
                  Solo articoli selezionati e scontati fino al −60%. Ogni giorno nuove occasioni, nuove collezioni e un'esperienza semplice e veloce. Abbigliamento, scarpe e accessori dei migliori brand internazionali, tutti in un unico posto.
                </p>
              </div>
              <div>
                <h2 className="font-medium text-lg sm:text-xl md:text-2xl md:font-semibold text-stone-900 tracking-tight mb-4">La nostra filosofia</h2>
                <p className="text-stone-500 text-sm leading-relaxed">
                  Crediamo in uno shopping consapevole. Rendiamo la moda accessibile a tutti — qualità reale, prezzi onesti, servizio impeccabile. La tua esperienza d'acquisto deve essere semplice, veloce e soddisfacente.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="py-20 bg-stone-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <p className="text-[10px] tracking-[0.3em] uppercase text-emerald-600 font-semibold mb-3">I nostri principi</p>
              <h2 className="font-semibold text-xl sm:text-2xl md:text-4xl md:font-bold text-stone-900 tracking-tight">Cosa ci guida</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-stone-200">
              {values.map(({ title, desc }) => (
                <div key={title} className="bg-white p-8 hover:bg-stone-50 transition-colors">
                  <h3 className="text-[10px] tracking-[0.25em] uppercase text-stone-900 font-semibold mb-4">{title}</h3>
                  <p className="text-stone-500 text-sm leading-relaxed">{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Timeline */}
        <section className="py-20 bg-white">
          <div className="max-w-3xl mx-auto px-6">
            <div className="text-center mb-16">
              <p className="text-[10px] tracking-[0.3em] uppercase text-emerald-600 font-semibold mb-3">La nostra storia</p>
              <h2 className="font-semibold text-xl sm:text-2xl md:text-4xl md:font-bold text-stone-900 tracking-tight">Le tappe fondamentali</h2>
            </div>
            <div className="space-y-0">
              {timeline.map(({ year, label }, i) => (
                <div key={year} className="flex gap-8 items-start">
                  <div className="flex flex-col items-center shrink-0">
                    <div className="size-3 rounded-full bg-emerald-500 mt-1.5" />
                    {i < timeline.length - 1 && <div className="w-px flex-1 bg-stone-200 mt-2 mb-0 min-h-12" />}
                  </div>
                  <div className="pb-10">
                    <p className="font-bold text-emerald-600 text-lg tracking-tight">{year}</p>
                    <p className="text-stone-600 text-sm mt-1">{label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="bg-stone-900 py-20">
          <div className="max-w-5xl mx-auto px-4">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-12 text-center">
              {[
                { value: "−70%", label: "Sconto massimo" },
                { value: "50+", label: "Brand internazionali" },
                { value: "14 gg", label: "Reso garantito" },
                { value: "10+", label: "Paesi Europa" },
              ].map(({ value, label }) => (
                <div key={label}>
                  <p className="font-semibold text-3xl sm:text-4xl md:text-5xl md:font-bold text-emerald-400 tracking-tight">{value}</p>
                  <p className="text-stone-400 text-xs tracking-wider uppercase mt-2">{label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonianze */}
        <section className="py-20 bg-stone-50">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-14">
              <p className="text-[10px] tracking-[0.3em] uppercase text-emerald-600 font-semibold mb-3">Recensioni</p>
              <h2 className="font-semibold text-xl sm:text-2xl md:text-3xl md:font-bold text-stone-900 tracking-tight">Cosa dicono i Bruper</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {[
                { text: "Servizio impeccabile e articoli davvero selezionati. Ho acquistato una borsa firmata a un prezzo ottimo. Spedizione rapida e confezione curata.", author: "Chiara B.", country: "Italia" },
                { text: "Qualità eccellente e supporto clienti molto reattivo. Ho scritto su WhatsApp e mi hanno risposto subito. Il pacco è arrivato in tre giorni.", author: "Jonas K.", country: "Germania" },
                { text: "Ho preso delle sneakers Diesel: arrivate in 48 ore, perfette. Prezzo imbattibile rispetto ai negozi fisici.", author: "Tobias W.", country: "Germania" },
                { text: "Già al secondo ordine. La selezione cambia spesso e si trovano sempre buone occasioni. Lo consiglio a tutti.", author: "Anna L.", country: "Germania" },
              ].map(({ text, author, country }) => (
                <div key={author} className="bg-white p-8 border border-stone-100">
                  <p className="text-stone-600 text-sm leading-relaxed italic mb-5">"{text}"</p>
                  <p className="text-stone-900 text-xs font-semibold tracking-wide">{author}</p>
                  <p className="text-stone-400 text-xs mt-0.5">{country}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 bg-white text-center">
          <p className="text-[10px] tracking-[0.3em] uppercase text-emerald-600 font-semibold mb-4">Diventa un Bruper</p>
          <h2 className="font-semibold text-2xl sm:text-3xl md:text-4xl md:font-bold text-stone-900 tracking-tight mb-4">
            Sconti esclusivi solo per la nostra community
          </h2>
          <p className="text-stone-500 text-sm mb-8">Iscriviti alla newsletter e ricevi il 10% di sconto sul primo ordine.</p>
          <NavLink
            to="/shop"
            className="inline-block text-[10px] tracking-widest uppercase bg-stone-900 text-white px-12 py-4 hover:bg-stone-700 transition-colors"
          >
            Scopri i prodotti
          </NavLink>
        </section>
      </main>
      <Footer />
    </div>
  );
}
